import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-02/lesson-12/task-03";

const task: Slide = {
  title: "Which of the following is a correct depiction of how ITD changes with azimuth angle (Φ)?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
